/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const o=5e4;class r{constructor(){this.objects=[]}init(e){let t;for(let s=0;s<e.length;s++)s%o===0&&(t={},this.objects.push(t)),t[e[s]]=!0}hasId(e){return this.objects.some(t=>t[e])}}exports.SortedPublicItemIds=r;
